import { render, staticRenderFns } from "./usSetupConfirmation.vue?vue&type=template&id=dfc332a8&scoped=true"
import script from "./usSetupConfirmation.vue?vue&type=script&lang=js"
export * from "./usSetupConfirmation.vue?vue&type=script&lang=js"
import style0 from "./usSetupConfirmation.vue?vue&type=style&index=0&id=dfc332a8&prod&lang=less&scoped=true"
import style1 from "./usSetupConfirmation.vue?vue&type=style&index=1&id=dfc332a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc332a8",
  null
  
)

export default component.exports